// extracted by mini-css-extract-plugin
export var byLine = "Byline-module--byLine--91bba";